import { drmExpireTableData } from "../../service/drmExpireTableData";
import {
  setExpireDrmTableDataSuccess,
  setExpireDrmTableDataFailure,
} from "../reducers/drmExpireTableDataSlice";

import { put, takeLatest, call } from "redux-saga/effects";

export function* workerExpireDrmTableData(action) {
  const { payload } = action;

  try {
    const response = yield call(drmExpireTableData, [
      payload.userCode,
      payload.submitDetails,
      payload.tableName,
      payload.controller,
    ]);

    const detailsRoot = response?.data?.details;
    const detailsData = detailsRoot?.data;
    const details =
      (detailsData && typeof detailsData === "object" ? detailsData : detailsRoot) ||
      {};

      const toArray = (records) => (Array.isArray(records) ? records : []);
      const errorRecords = toArray(details?.errorRecords);
      const successRecords = toArray(details?.successRecords);

        const formatRecordMessages = (records = [], label) => {
            if (!records.length) {
                return "";
            }
            const formattedRows = records                .map((record, index) => {
                    const sagaId = record?.sagaId ?? `Row-${index + 1}`;
                    const message = record?.message ?? "No message provided";
                    return `${index + 1}. Saga ID: ${sagaId} - ${message}`;
                })                .join("\n");
            return label ? `${label}:\n${formattedRows}` : formattedRows;
        };

        const responseMessage = response?.data?.message;
        const messageSegments = [
            formatRecordMessages(errorRecords, "Failed expirations"),
            formatRecordMessages(successRecords, "Successful expirations"),
            //responseMessage,
        ].filter(Boolean);

        const combinedPayload = messageSegments.join("\n\n") || responseMessage;

    yield put(setExpireDrmTableDataSuccess(combinedPayload));
  } catch (error) {
    yield put(setExpireDrmTableDataFailure(error.toString()));
  }
}

function* drmExpireTableDataSaga() {
  yield takeLatest(
    "expireDrmtTableData/setExpireDrmTableData",
    workerExpireDrmTableData
  );
}

export default drmExpireTableDataSaga;
